import moment from "moment";
import { store } from "@redux";
import {
  checkJsonExist,
  checkJsonProp,
  formatDate,
  getClassificators,
  getClassificatorsConst,
  removeAllWhiteSpaces,
  removeWhiteSpacesStartEndOnly
} from "@utilities";

export const remapNewValues = newValues => {
  const classificators = getClassificators();
  const classificatorsConst = getClassificatorsConst();
  const classifikatorsMap = (type, withoutSort = true) => {
    const obj = checkJsonProp(classificators, type),
      newObj = checkJsonProp(classificatorsConst, type),
      objectMap = obj =>
        Object.entries(obj)
          .map(item => {
            return item[0] && item[1]
              ? { label: item[1], value: item[0] }
              : item[0]
              ? { label: item[0], value: item[0] }
              : null;
          })
          .filter(item => item)
          .sort((a, b) => {
            return withoutSort ? 1 : a.label > b.label ? 1 : a.label < b.label ? -1 : 0; // TODO: is this correct?
          });

    return obj ? objectMap(obj) : newObj ? objectMap(newObj) : [];
  };
  const PEN = classifikatorsMap("PEN"),
    CBBSN = classifikatorsMap("CBBSN", true),
    CFUSC = classifikatorsMap("CFUSC", true),
    CFURC = classifikatorsMap("CFURC", true),
    CBP = classifikatorsMap("CBP"),
    BENEF = classifikatorsMap("BENEF"),
    TAXC = classifikatorsMap("TAXC");

  //Remap add datetime to YYYY-MM-DD
  newValues.clientBeneficiaries = newValues.clientBeneficiaries.map((item, index) => {
    item.data.clientBenefBirthDate = moment(item.data.clientBenefBirthDate).format("YYYY-MM-DD");
    return item;
  });
  newValues.clientProfile[0].data.clientBirthDate = moment(
    newValues.clientProfile[0].data.clientBirthDate
  ).format("YYYY-MM-DD");
  newValues.clientCeo[0].data.clientCeoDocIssueDate = moment(
    newValues.clientCeo[0].data.clientCeoDocIssueDate
  ).format("YYYY-MM-DD");
  newValues.clientCeo[0].data.clientCeoDocValidDate = moment(
    newValues.clientCeo[0].data.clientCeoDocValidDate
  ).format("YYYY-MM-DD");
  newValues.clientCeo[0].data.managerBirthDate = moment(
    newValues.clientCeo[0].data.managerBirthDate
  ).format("YYYY-MM-DD");
  if (checkJsonProp(newValues, "clientRep.0.data.clientRepBirthDate")) {
    newValues.clientRep[0].data.clientRepBirthDate = moment(
      newValues.clientRep[0].data.clientRepBirthDate
    ).format("YYYY-MM-DD");
  }
  if (checkJsonProp(newValues, "clientRep.0.data.clientRepDocIssueDate")) {
    newValues.clientRep[0].data.clientRepDocIssueDate = moment(
      newValues.clientRep[0].data.clientRepDocIssueDate
    ).format("YYYY-MM-DD");
  }
  if (checkJsonProp(newValues, "clientRep.0.data.clientRepDocValidDate")) {
    newValues.clientRep[0].data.clientRepDocValidDate = moment(
      newValues.clientRep[0].data.clientRepDocValidDate
    ).format("YYYY-MM-DD");
  }
  if (checkJsonProp(newValues, "clientRep.0.data.clientRepMandatValidDate")) {
    newValues.clientRep[0].data.clientRepMandatValidDate = moment(
      newValues.clientRep[0].data.clientRepMandatValidDate
    ).format("YYYY-MM-DD");
  }
  // Clearing
  if (checkJsonExist(newValues, "Approve")) delete newValues.Approve;
  if (checkJsonProp(newValues, "clientPhone"))
    newValues.clientPhone.forEach(item => {
      if (checkJsonExist(item, "data.clientPhoneNoPrefix")) delete item.data.clientPhoneNoPrefix;
      if (checkJsonExist(item, "data.clientPhoneNoStr")) delete item.data.clientPhoneNoStr;
    });
  if (checkJsonProp(newValues, "clientCeo"))
    newValues.clientCeo.forEach(item => {
      if (checkJsonExist(item, "data.clientCeoPhonePrefix")) delete item.data.clientCeoPhonePrefix;
      if (checkJsonExist(item, "data.clientCeoPhoneStr")) delete item.data.clientCeoPhoneStr;
    });
  if (checkJsonProp(newValues, "clientRep"))
    newValues.clientRep.forEach(item => {
      if (checkJsonExist(item, "data.clientRepPhoneNoPrefix"))
        delete item.data.clientRepPhoneNoPrefix;
      if (checkJsonExist(item, "data.clientCeoPhoneStr")) delete item.data.clientCeoPhoneStr;
    });
  if (checkJsonProp(newValues, "clientBeneficiaries"))
    newValues.clientBeneficiaries.forEach(item => {
      if (checkJsonExist(item, "data.clientBenefPhonePrefix"))
        delete item.data.clientBenefPhonePrefix;
      if (checkJsonExist(item, "data.clientBenefPhoneStr")) delete item.data.clientBenefPhoneStr;
    });
  if (checkJsonExist(newValues, "companyName")) delete newValues.companyName;
  if (checkJsonProp(newValues, "clientProfile.0.data.whoOpenAccount") === "CMP1") {
    newValues.clientRep = [];
  }
  newValues.clientPlanCashTurn = [];
  newValues.companyFunds =
    !checkJsonProp(newValues, "companyFunds.0.data") ||
    (checkJsonProp(newValues, "companyFunds.0.data") &&
      Object.keys(newValues.companyFunds[0].data).length === 0)
      ? []
      : newValues.companyFunds;
  newValues.clientPlanServices =
    !checkJsonProp(newValues, "clientPlanServices.0.data") ||
    (checkJsonProp(newValues, "clientPlanServices.0.data") &&
      Object.keys(newValues.companyFunds[0].data).length === 0)
      ? []
      : newValues.clientPlanServices;
  newValues.PaymOut =
    !checkJsonProp(newValues, "PaymOut.0.data") ||
    (checkJsonProp(newValues, "PaymOut.0.data") &&
      Object.keys(newValues.PaymOut[0].data).length === 0)
      ? []
      : newValues.PaymOut;
  newValues.planServTurn =
    !checkJsonProp(newValues, "planServTurn.0.data") ||
    (checkJsonProp(newValues, "planServTurn.0.data") &&
      Object.keys(newValues.planServTurn[0].data).length === 0)
      ? []
      : newValues.planServTurn;
  newValues.clientPolitics =
    !checkJsonProp(newValues, "clientPolitics.0.data") ||
    (checkJsonProp(newValues, "clientPolitics.0.data") &&
      Object.keys(newValues.clientPolitics[0].data).length === 0)
      ? []
      : newValues.clientPolitics;
  newValues.clientPoliticsPosition =
    !checkJsonProp(newValues, "clientPoliticsPosition.0.data") ||
    (checkJsonProp(newValues, "clientPoliticsPosition.0.data") &&
      Object.keys(newValues.clientPoliticsPosition[0].data).length === 0)
      ? []
      : newValues.clientPoliticsPosition;
  if (checkJsonProp(newValues, "mainCustom.0.customerEmpty")) {
    newValues.mainCustom = [];
  }
  if (checkJsonProp(newValues, "clientBusPartner.0.clientBusPartnerEmpty")) {
    newValues.clientBusPartner = [];
  }

  if (checkJsonExist(newValues, "companyFunds.0.companyFundsValid"))
    delete newValues.companyFunds[0].companyFundsValid;
  if (checkJsonExist(newValues, "clientPoliticsPosition.0.clientPoliticsValid"))
    delete newValues.clientPoliticsPosition[0].clientPoliticsValid;
  if (checkJsonExist(newValues, "clientAddress.0.clientSameRealAddress"))
    delete newValues.clientAddress[0].clientSameRealAddress;
  if (checkJsonExist(newValues, "mainCustom.0.customerEmpty"))
    delete newValues.mainCustom[0].customerEmpty;
  if (checkJsonExist(newValues, "clientBusPartner.0.clientBusPartnerEmpty"))
    delete newValues.clientBusPartner[0].clientBusPartnerEmpty;

  //Remap types in canDuplicated and specific remap
  if (checkJsonProp(newValues, "clientTaxPayerCountrys"))
    newValues.clientTaxPayerCountrys.forEach((item, index) => {
      item.clientTaxPayerCountryType = TAXC[index].value;
    });
  if (checkJsonProp(newValues, "clientAddress"))
    newValues.clientAddress.forEach((item, index) => {
      item.addressType = index === 0 ? "ADRT2" : "ADRT1";
    });
  if (checkJsonProp(newValues, "clientBeneficiaries"))
    newValues.clientBeneficiaries.forEach((item, index) => {
      item.clientBenefType = BENEF[index].value;
    });
  if (checkJsonProp(newValues, "clientBasicBusiness"))
    newValues.clientBasicBusiness.forEach((item, index) => {
      item.clientBasicBusinessType = CBBSN[index].value;
    });
  if (checkJsonProp(newValues, "clientFundsRecCountrys"))
    newValues.clientFundsRecCountrys.forEach((item, index) => {
      item.clientFundsRecCountryType = CFURC[index].value;
    });
  if (checkJsonProp(newValues, "mainCustom"))
    newValues.mainCustom.forEach((item, index) => {
      item.mainCustom = PEN[index].value;
    });
  if (checkJsonProp(newValues, "clientFundsSentCountry"))
    newValues.clientFundsSentCountry.forEach((item, index) => {
      item.clientFundsSentCountryType = CFUSC[index].value;
    });
  if (checkJsonProp(newValues, "clientBusPartner"))
    newValues.clientBusPartner.forEach((item, index) => {
      item.cientBusPartnerType = CBP[index].value;
    });
  if (checkJsonExist(newValues, "clientProfile.0.data.clientBirthDate"))
    newValues.clientProfile[0].data.clientBirthDate = formatDate(
      newValues.clientProfile[0].data.clientBirthDate
    );
  if (checkJsonExist(newValues, "clientCeo.0.data.managerBirthDate"))
    newValues.clientCeo[0].data.managerBirthDate = formatDate(
      newValues.clientCeo[0].data.managerBirthDate
    );
  if (checkJsonExist(newValues, "clientRep.0.data.clientRepBirthDate"))
    newValues.clientRep[0].data.clientRepBirthDate = formatDate(
      newValues.clientRep[0].data.clientRepBirthDate
    );
  if (checkJsonProp(newValues, "companyFunds.0.data.other")) {
    newValues.companyFunds[0].data.other = newValues.companyFunds[0].data.otherInput;
    delete newValues.companyFunds[0].data.otherInput;
  }

  // Clearing whitespaces
  if (checkJsonProp(newValues, "clientProfile.0.data.clientId")) {
    let clientId = newValues.clientProfile[0].data.clientId;
    clientId = removeAllWhiteSpaces(clientId);
    newValues.clientProfile[0].data.clientId = clientId;
  }
  if (checkJsonProp(newValues, "clientProfile.0.data.clientTitle")) {
    let clientTitle = newValues.clientProfile[0].data.clientTitle;
    clientTitle = removeWhiteSpacesStartEndOnly(clientTitle);
    newValues.clientProfile[0].data.clientTitle = clientTitle;
  }
  if (checkJsonProp(newValues, "clientAddress.0.data.addressCity")) {
    let addressCity = newValues.clientAddress[0].data.addressCity;
    addressCity = removeWhiteSpacesStartEndOnly(addressCity);
    newValues.clientAddress[0].data.addressCity = addressCity;
  }
  if (checkJsonProp(newValues, "clientAddress.0.data.addressStreet")) {
    let addressStreet = newValues.clientAddress[0].data.addressStreet;
    addressStreet = removeWhiteSpacesStartEndOnly(addressStreet);
    newValues.clientAddress[0].data.addressStreet = addressStreet;
  }
  if (checkJsonProp(newValues, "clientAddress.0.data.addressPostCode")) {
    let addressPostCode = newValues.clientAddress[0].data.addressPostCode;
    addressPostCode = removeWhiteSpacesStartEndOnly(addressPostCode);
    newValues.clientAddress[0].data.addressPostCode = addressPostCode;
  }
  if (checkJsonProp(newValues, "clientAddress.1.data.addressCity")) {
    let addressCity = newValues.clientAddress[1].data.addressCity;
    addressCity = removeWhiteSpacesStartEndOnly(addressCity);
    newValues.clientAddress[1].data.addressCity = addressCity;
  }
  if (checkJsonProp(newValues, "clientAddress.1.data.addressStreet")) {
    let addressStreet = newValues.clientAddress[1].data.addressStreet;
    addressStreet = removeWhiteSpacesStartEndOnly(addressStreet);
    newValues.clientAddress[1].data.addressStreet = addressStreet;
  }
  if (checkJsonProp(newValues, "clientAddress.1.data.addressPostCode")) {
    let addressPostCode = newValues.clientAddress[1].data.addressPostCode;
    addressPostCode = removeWhiteSpacesStartEndOnly(addressPostCode);
    newValues.clientAddress[1].data.addressPostCode = addressPostCode;
  }
  if (checkJsonProp(newValues, "clientTaxPayerCountrys.0.data.clientTaxPayerId")) {
    let clientTaxPayerId = newValues.clientTaxPayerCountrys[0].data.clientTaxPayerId;
    clientTaxPayerId = removeAllWhiteSpaces(clientTaxPayerId);
    newValues.clientTaxPayerCountrys[0].data.clientTaxPayerId = clientTaxPayerId;
  }
  if (checkJsonProp(newValues, "clientProfile.0.data.clientRepPosition")) {
    let clientRepPosition = newValues.clientProfile[0].data.clientRepPosition;
    clientRepPosition = removeWhiteSpacesStartEndOnly(clientRepPosition);
    newValues.clientProfile[0].data.clientRepPosition = clientRepPosition;
  }
  if (checkJsonProp(newValues, "clientCeo.0.data.clientCeoName")) {
    let clientCeoName = newValues.clientCeo[0].data.clientCeoName;
    clientCeoName = removeWhiteSpacesStartEndOnly(clientCeoName);
    newValues.clientCeo[0].data.clientCeoName = clientCeoName;
  }
  if (checkJsonProp(newValues, "clientCeo.0.data.clientCeoSurname")) {
    let clientCeoSurname = newValues.clientCeo[0].data.clientCeoSurname;
    clientCeoSurname = removeWhiteSpacesStartEndOnly(clientCeoSurname);
    newValues.clientCeo[0].data.clientCeoSurname = clientCeoSurname;
  }
  if (checkJsonProp(newValues, "clientCeo.0.data.clientCeoId")) {
    let clientCeoId = newValues.clientCeo[0].data.clientCeoId;
    clientCeoId = removeAllWhiteSpaces(clientCeoId);
    newValues.clientCeo[0].data.clientCeoId = clientCeoId;
  }
  if (checkJsonProp(newValues, "clientCeo.0.data.clientCeoCity")) {
    let clientCeoCity = newValues.clientCeo[0].data.clientCeoCity;
    clientCeoCity = removeWhiteSpacesStartEndOnly(clientCeoCity);
    newValues.clientCeo[0].data.clientCeoCity = clientCeoCity;
  }
  if (checkJsonProp(newValues, "clientCeo.0.data.clientCeoStreet")) {
    let clientCeoStreet = newValues.clientCeo[0].data.clientCeoStreet;
    clientCeoStreet = removeWhiteSpacesStartEndOnly(clientCeoStreet);
    newValues.clientCeo[0].data.clientCeoStreet = clientCeoStreet;
  }
  if (checkJsonProp(newValues, "clientCeo.0.data.clientCeoDocNo")) {
    let clientCeoDocNo = newValues.clientCeo[0].data.clientCeoDocNo;
    clientCeoDocNo = removeAllWhiteSpaces(clientCeoDocNo);
    newValues.clientCeo[0].data.clientCeoDocNo = clientCeoDocNo;
  }
  if (checkJsonProp(newValues, "clientRep.0.data.clientRepName")) {
    let clientRepName = newValues.clientRep[0].data.clientRepName;
    clientRepName = removeWhiteSpacesStartEndOnly(clientRepName);
    newValues.clientRep[0].data.clientRepName = clientRepName;
  }
  if (checkJsonProp(newValues, "clientRep.0.data.clientRepSurname")) {
    let clientRepSurname = newValues.clientRep[0].data.clientRepSurname;
    clientRepSurname = removeWhiteSpacesStartEndOnly(clientRepSurname);
    newValues.clientRep[0].data.clientRepSurname = clientRepSurname;
  }
  if (checkJsonProp(newValues, "clientRep.0.data.clientRepId")) {
    let clientRepId = newValues.clientRep[0].data.clientRepId;
    clientRepId = removeAllWhiteSpaces(clientRepId);
    newValues.clientRep[0].data.clientRepId = clientRepId;
  }
  if (checkJsonProp(newValues, "clientRep.0.data.clientRepCity")) {
    let clientRepCity = newValues.clientRep[0].data.clientRepCity;
    clientRepCity = removeWhiteSpacesStartEndOnly(clientRepCity);
    newValues.clientRep[0].data.clientRepCity = clientRepCity;
  }
  if (checkJsonProp(newValues, "clientRep.0.data.clientRepStreet")) {
    let clientRepStreet = newValues.clientRep[0].data.clientRepStreet;
    clientRepStreet = removeWhiteSpacesStartEndOnly(clientRepStreet);
    newValues.clientRep[0].data.clientRepStreet = clientRepStreet;
  }
  if (checkJsonProp(newValues, "clientRep.0.data.clientRepDocNo")) {
    let clientRepDocNo = newValues.clientRep[0].data.clientRepDocNo;
    clientRepDocNo = removeWhiteSpacesStartEndOnly(clientRepDocNo);
    newValues.clientRep[0].data.clientRepDocNo = clientRepDocNo;
  }
  if (checkJsonProp(newValues, "clientBeneficiaries.0.data.clientBenefId")) {
    let clientBenefId = newValues.clientBeneficiaries[0].data.clientBenefId;
    clientBenefId = removeAllWhiteSpaces(clientBenefId);
    newValues.clientBeneficiaries[0].data.clientBenefId = clientBenefId;
  }
  if (checkJsonProp(newValues, "clientBeneficiaries.1.data.clientBenefId")) {
    let clientBenefId = newValues.clientBeneficiaries[1].data.clientBenefId;
    clientBenefId = removeAllWhiteSpaces(clientBenefId);
    newValues.clientBeneficiaries[1].data.clientBenefId = clientBenefId;
  }
  if (checkJsonProp(newValues, "clientBeneficiaries.2.data.clientBenefId")) {
    let clientBenefId = newValues.clientBeneficiaries[2].data.clientBenefId;
    clientBenefId = removeAllWhiteSpaces(clientBenefId);
    newValues.clientBeneficiaries[2].data.clientBenefId = clientBenefId;
  }
  if (checkJsonProp(newValues, "clientBeneficiaries.0.data.clientBenefTaxId")) {
    let clientBenefTaxId = newValues.clientBeneficiaries[0].data.clientBenefTaxId;
    clientBenefTaxId = removeWhiteSpacesStartEndOnly(clientBenefTaxId);
    newValues.clientBeneficiaries[0].data.clientBenefTaxId = clientBenefTaxId;
  }
  if (checkJsonProp(newValues, "clientBeneficiaries.1.data.clientBenefTaxId")) {
    let clientBenefTaxId = newValues.clientBeneficiaries[1].data.clientBenefTaxId;
    clientBenefTaxId = removeWhiteSpacesStartEndOnly(clientBenefTaxId);
    newValues.clientBeneficiaries[1].data.clientBenefTaxId = clientBenefTaxId;
  }
  if (checkJsonProp(newValues, "clientBeneficiaries.2.data.clientBenefTaxId")) {
    let clientBenefTaxId = newValues.clientBeneficiaries[2].data.clientBenefTaxId;
    clientBenefTaxId = removeWhiteSpacesStartEndOnly(clientBenefTaxId);
    newValues.clientBeneficiaries[2].data.clientBenefTaxId = clientBenefTaxId;
  }
  if (checkJsonProp(newValues, "clientBeneficiaries.0.data.clientBenefDocNo")) {
    let clientBenefDocNo = newValues.clientBeneficiaries[0].data.clientBenefDocNo;
    clientBenefDocNo = removeWhiteSpacesStartEndOnly(clientBenefDocNo);
    newValues.clientBeneficiaries[0].data.clientBenefDocNo = clientBenefDocNo;
  }
  if (checkJsonProp(newValues, "clientBeneficiaries.1.data.clientBenefDocNo")) {
    let clientBenefDocNo = newValues.clientBeneficiaries[1].data.clientBenefDocNo;
    clientBenefDocNo = removeWhiteSpacesStartEndOnly(clientBenefDocNo);
    newValues.clientBeneficiaries[1].data.clientBenefDocNo = clientBenefDocNo;
  }
  if (checkJsonProp(newValues, "clientBeneficiaries.2.data.clientBenefDocNo")) {
    let clientBenefDocNo = newValues.clientBeneficiaries[2].data.clientBenefDocNo;
    clientBenefDocNo = removeWhiteSpacesStartEndOnly(clientBenefDocNo);
    newValues.clientBeneficiaries[2].data.clientBenefDocNo = clientBenefDocNo;
  }

  if (checkJsonProp(newValues, "clientPoliticsPosition.0.data.clientPoliticOther")) {
    newValues.clientPoliticsPosition[0].data.clientPoliticOther =
      newValues.clientPoliticsPosition[0].data.clientPoliticOtherInput;
    delete newValues.clientPoliticsPosition[0].data.clientPoliticOtherInput;
  }

  if (checkJsonProp(newValues, "clientBeneficiaries.0.uboretail")) {
    delete newValues.clientBeneficiaries[0].uboretail;
  }

  if (newValues?.mainCustom?.[0]?.checkedRetailOrEmpty) {
    delete newValues.mainCustom[0].mainCustom;
    delete newValues.mainCustom[0].data;
  }
  if (
    newValues?.mainCustom?.[0]?.checkedRetailOrEmpty ||
    newValues?.mainCustom?.[0]?.checkedRetailOrEmpty === false
  ) {
    delete newValues.mainCustom[0].checkedRetailOrEmpty;
  }
  if (newValues?.clientBasicBusiness?.[0]?.data?.clientBasicBusinessMainGroups) {
    delete newValues?.clientBasicBusiness?.[0]?.data?.clientBasicBusinessMainGroups;
  }

  const state = store.getState();
  const {
    companyTypes
  } = state.KYCReducers?.applicationKYC?.applicationState?.prefillData?.companyTypesList;

  const companyTypeTextValue =
    companyTypes?.find(
      el => el.companyCode === newValues.clientProfile?.[0]?.data.clientLegalStatus
    )?.companyDescription ?? "";

  newValues.clientProfile[0].data.companyTypeTextValue = companyTypeTextValue;

  return newValues;
};
